import React, { useEffect, useState } from 'react'
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom'

//pages


import Dashboard from '../pages/common/dashboard'
import CreateShipment from '../pages/vandor/create-shipment'
import TrackShipment from '../pages/common/track-shipment'
import AllShipments from '../pages/common/all-shipments'
import Analytics from "../pages/common/today-analytics"
import AllTransections from '../pages/common/all-transections'


import ForgetPasswordPage from '../pages/auth/forget-password'
import LoginPage from '../pages/auth/login'
import NewPassPage from '../pages/auth/new-password'
import SignUpPage from '../pages/auth/signup'
import EmailVerificationPage from '../pages/auth/verify-email'


import PendingUsers from "../pages/admin/requests-management"
import ProcessShipments from '../pages/admin/assign-shipments'


import UpdateStatus from '../pages/rider/update-status'

//components
import Layout from '../components/layout'

const RouterLinks = ({
	user }) => {

	return (
		<BrowserRouter>
			<Routes>
				<Route
					path='/'
					element={
						<Layout user={user} showNavbar={true}>
							{user.role === 'admin' && user.isLoggedIn ? <Navigate to='/analytics' /> :
								user.role === 'rider' && user.isLoggedIn ? <Navigate to='/analytics' /> :
									user.role === 'vendor' && user.isLoggedIn ? <Navigate to='/analytics' /> :
										<Navigate to='/login' />}
						</Layout>
					}
				/>
				{/* <Route
					path='/'
					element={
						<LandingPage/>
					}
				/> */}
				<Route
					path='/login'
					element={
						!user.isLoggedIn ? <LoginPage /> : <Navigate to='/' />
					}
				/>
				<Route
					path='/signup'
					element={
						!user.isLoggedIn ? <SignUpPage /> : <Navigate to='/' />
					}
				/>
				<Route
					path='/forget-pass'
					element={<ForgetPasswordPage />}
				/>
				<Route
					path='/new-pass/:token'
					element={<NewPassPage />}
				/>
				<Route
					path='/verify-email/:verificationToken'
					element={<EmailVerificationPage />}
				/>
				{(user.role == 'vendor' || user.role == 'admin' || user.role == 'rider') && user.isLoggedIn &&
					<>
					<Route
							path='/analytics'
							element={
								<Layout user={user} showNavbar={true} footer={true}>
									<Analytics user={user} />
								</Layout>
							}
						/>
						<Route
							path='/dashboard'
							element={
								<Layout user={user} showNavbar={true} footer={true}>
									<Dashboard user={user} />
								</Layout>
							}
						/>

					</>
				}



				{(user.role == 'vendor' || user.role == 'admin') && user.isLoggedIn &&
					<>

						<Route
							path='/track'
							element={
								<Layout user={user} showNavbar={true} footer={true}>
								{user.isLoggedIn ? <TrackShipment user={user}/> : <Navigate to='/login' />}
								</Layout>
							}
						/>
						<Route
							path='/all-shipments'
							element={
								<Layout user={user} showNavbar={true} footer={true}>
									{user.isLoggedIn ? <AllShipments user={user} /> : <Navigate to='/login' />}
								</Layout>
							}
						/>
													<Route
								path='payments'
								element={
									<Layout user={user} showNavbar={true} footer={true}>
										{user.isLoggedIn ? <AllTransections user={user} /> : <Navigate to='/login' />}
									</Layout>
								}
							/>

					</>
				}


				{user.role === 'vendor' && user.isLoggedIn &&
					<>
						<Route
							path='/create-shipment'
							element={
								<Layout user={user} showNavbar={true} footer={true}>
									{user.isLoggedIn ? <CreateShipment user={user} /> : <Navigate to='/login' />}
								</Layout>
							}
						/>
					</>
				}

				{user.role === 'admin' && user.isLoggedIn &&
					<>
							<Route
								path='manage-users'
								element={
									<Layout user={user} showNavbar={true} footer={true}>
										{user.isLoggedIn ? <PendingUsers user={user} /> : <Navigate to='/login' />}
									</Layout>
								}
							/>
							<Route
								path='process-shipments'
								element={
									<Layout user={user} showNavbar={true} footer={true}>
										{user.isLoggedIn ? <ProcessShipments user={user} /> : <Navigate to='/login' />}
									</Layout>
								}
							/>

					</>
				}
				{(user.role == 'rider' || user.role == 'admin')&& user.isLoggedIn &&
					<>
						<Route
								path='update-status'
								element={
									<Layout user={user} showNavbar={true} footer={true}>
										{user.isLoggedIn ? <UpdateStatus user={user} isHist={false} /> : <Navigate to='/login' />}
									</Layout>
								}
							/>
					</>
				}
				{user.role === 'rider' && user.isLoggedIn &&
					<>

							<Route
								path='history'
								element={
									<Layout user={user} showNavbar={true} footer={true}>
										{user.isLoggedIn ? <UpdateStatus user={user} isHist={true} /> : <Navigate to='/login' />}
									</Layout>
								}
							/>

					</>
				}

				<Route
				path="*"
				element={
					<div
					style={{
						display: "flex",
						flexDirection: "column",
						justifyContent: "center",
						alignItems: "center",
						height: "100vh",
						textAlign: "center",
						backgroundColor: "#f8f9fa",
						color: "#343a40",
						fontFamily: "'Arial', sans-serif",
						padding: "20px",
					}}
					>
					<h1 style={{ fontSize: "4rem", marginBottom: "20px", color: "#005A9C" }}>
						404
					</h1>
					<h2 style={{ fontSize: "2rem", marginBottom: "10px" }}>Page Not Found</h2>
					<p style={{ fontSize: "1.2rem", marginBottom: "20px" }}>
						Oops! The page you are looking for doesn't exist or has been moved.
					</p>
					<a
						href="/"
						style={{
						textDecoration: "none",
						padding: "10px 20px",
						border: "2px solid #005A9C",
						borderRadius: "5px",
						color: "#005A9C",
						backgroundColor: "#ffffff",
						fontSize: "1rem",
						transition: "all 0.3s ease",
						}}
						onMouseOver={(e) => {
						e.target.style.backgroundColor = "#005A9C";
						e.target.style.color = "#ffffff";
						}}
						onMouseOut={(e) => {
						e.target.style.backgroundColor = "#ffffff";
						e.target.style.color = "#005A9C";
						}}
					>
						Go to Homepage
					</a>
					</div>
				}
				/>
			</Routes>
		</BrowserRouter>
	)
}

export default RouterLinks
